import React from 'react';
import styled from 'styled-components';

const Loading = () => {
    return (
        <LoadingWithStyled className="text-center">
            読み込み中です
        </LoadingWithStyled>
    );
};

const LoadingWithStyled = styled.div`
`

export default Loading;